import { onUnmounted, ref } from 'vue';
import { searchUsers } from '@/js/core/utils/trays-api';

export function useUserSearch(getExcludedUuids = () => []) {
  const searchQuery = ref('');
  const searchResults = ref([]);
  const searching = ref(false);

  let searchTimeout = null;

  const handleSearch = () => {
    clearTimeout(searchTimeout);
    const query = searchQuery.value.trim();

    if (query.length < 2) {
      searchResults.value = [];
      searching.value = false;
      return;
    }

    searching.value = true;
    searchTimeout = setTimeout(async () => {
      try {
        const result = await searchUsers(query);
        const excludedUuids = new Set((getExcludedUuids() || []).filter(Boolean));
        searchResults.value = (result.data || []).filter(user => !excludedUuids.has(user.uuid));
      } catch (e) {
        searchResults.value = [];
      } finally {
        searching.value = false;
      }
    }, 300);
  };

  const clearSearch = () => {
    clearTimeout(searchTimeout);
    searchQuery.value = '';
    searchResults.value = [];
    searching.value = false;
  };

  onUnmounted(() => {
    clearTimeout(searchTimeout);
  });

  return { searchQuery, searchResults, searching, handleSearch, clearSearch };
}
